/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient\src\Router\HeaderInteractionProvider.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient
 * Created Date: Friday November 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday November 10th 2023 11:03:03 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import UserService from "Services/Users/UserService";
import { createContext, ReactElement, useContext, useEffect, useMemo, useState } from "react";
import { CommercialType } from "Types/commercial.type";
import Cookie from "Cookies/CookieWrapper";
import CookiePathResolver from "Config/Cookies/CookiePathResolver";
import { useAuth } from "./AuthProvider";

const setMyFav = (bool: boolean, carID: string) => {
};
const setMyOfferCount = (bool: boolean) => {
};
const setMySellAgreement = (bool: boolean) => {
};

export const HeaderInteractionContext = createContext({userID: "", SellAgreement: false, SetSellAgreement: setMySellAgreement, FavCount: 0, fav: [""], setFav: setMyFav, OfferCount: 0, setOfferCount: setMyOfferCount, getContextData: () => {} });

export const InterractiveHeaderProvider = (props: {children: ReactElement<any, any>}) => {
  const { isConnected } = useAuth();
  const [sellAgreement, setMySellAgreement] = useState<boolean>(true);
  const [userID, setUserID] = useState<string>("");
  const [fav, setFav] = useState<string[]>([]);
  const [offerCount, setOfferCount] = useState<number>(0);
  const [boughtCount, setBoughtCount] = useState<number>(0);
  const [myCommercialInfo, setMyCommercialInfo] = useState<CommercialType>({
    FirstName: "",
    LastName: "",
    Email: "",
    Cellphone: ""
  });

  const getContextData = () => {
    const token = Cookie.getCookie(CookiePathResolver.USER.TOKEN);
    if (token) {
      UserService.getMe().then((res: {data: {offer: number, favorite: {CarID: string}[], userID: string, sellAgreement: {SellAgreementTime : Date | null}}}) => {
        setFav(res.data.favorite.map(x => x.CarID));
        setOfferCount(res.data.offer);
        setUserID(res.data.userID);
        if (res.data.sellAgreement.SellAgreementTime) {
          setSellAgreement(true);
        } else {
          setSellAgreement(false);
        }
      }).catch((e) => {
        console.error(`Something went wrong while pulling context: ${JSON.stringify(e)}`);
      });
    }
  };

  useEffect (() => {
    getContextData();
  }, [, isConnected]);

  const handleChangeFav = (bool: boolean, carID: string) => {
    if (!bool) {
      setFav(fav.filter(x => x !== carID));
    } else {
      setFav([...fav, carID]);
    }
  };

  const IncreaseOfferCount = (bool: boolean) => {
    if (bool)
      setOfferCount(offerCount + 1);
    else
      setOfferCount(offerCount - 1);
  };

  const setSellAgreement = (bool: boolean) => {
    setMySellAgreement(bool);
  };

  const value = useMemo(() => {
    return {
      Commercial: {
        ...myCommercialInfo
      },
      userID: userID,
      SellAgreement: sellAgreement,
      SetSellAgreement: setSellAgreement,
      fav: fav,
      FavCount: fav.length,
      setFav: handleChangeFav,
      OfferCount: offerCount,
      setOfferCount: IncreaseOfferCount,
      BoughtCount: boughtCount,
      getContextData
    }},
    [myCommercialInfo, fav, offerCount, boughtCount, sellAgreement]
  );

  return (<HeaderInteractionContext.Provider value={value}>{props.children}</HeaderInteractionContext.Provider>);
};

export const useInteractiveHeader = () => {
  return useContext(HeaderInteractionContext);
};
